import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { Button } from 'antd';

import Modal from '/ui/Modal';

import CLIENT from '../../../client/actionTypes';
import RecoveryPassword from './index';

import { AppDispatch, ReduxState } from '../../../../types/app';

const DialogRecoveryPassword = () => {
  const intl = useIntl();
  const dispatch = useDispatch<AppDispatch>();
  const [visible, setVisible] = useState(false);

  const email = useSelector(
    (state: ReduxState) =>
      state.ClientPersonalInfo.info?.Email ?? state.Client.data?.Email ?? '',
    shallowEqual
  );

  const openModal = () => {
    dispatch({ type: CLIENT.RECOVERY_PASSWORD.SEND_CODE.INVALID });
    setVisible(true);
  };

  return (
    <>
      <Button
        type="link"
        className="profile-form__forgot-btn"
        onClick={openModal}
        size="small"
      >
        {intl.formatMessage({ id: 'links.forgotPassword' })}
      </Button>

      <Modal
        className="profile-recovery-modal"
        open={visible}
        onCancel={() => setVisible(false)}
        footer={null}
        centered
        destroyOnHidden
        width={480}
      >
        <RecoveryPassword currentEmail={email} />
      </Modal>
    </>
  );
};

export default DialogRecoveryPassword;
